import {FormElement} from "./FormElement";
import {FormBuilder} from "../FormBuilder";
import {MapSVG} from "../../Core/globals.js";
import {SchemaField} from "../../Infrastructure/Server/SchemaField";
import {Server} from "../../Infrastructure/Server/Server";
const $ = jQuery;

export class PostFormElement extends FormElement {

    id: number;
    post_id: number;
    post?: {
        id: number,
        post_content: string,
        post_title: string,
        url: string,
        acf?: {[key: string]: any}
    };
    add_fields: boolean;
    post_type: boolean;
    post_types: string[];


    constructor(options: SchemaField, formBuilder: FormBuilder, external: {[key: string]: any}) {
        super(options, formBuilder, external);

        if (this.formBuilder.admin) this.post_types = this.formBuilder.admin.getPostTypes();
        this.post_type = options.post_type || this.post_types[0];
        this.add_fields = MapSVG.parseBoolean(options.add_fields);
        this.db_type = 'int(11)';
        this.name = 'post_id';
        this.post_id = options.post_id;
        this.post = options.post;

    }

    setDomElements() {
        super.setDomElements();
        this.inputs.postSelect = <HTMLSelectElement>$(this.domElements.main).find(".mapsvg-find-post")[0];
        this.inputs.postId = <HTMLInputElement>$(this.domElements.main).find('input[name="post_id"]')[0];
    }


    getSchema(): { [p: string]: any } {
        let schema = super.getSchema();
        schema.post_type = this.post_type;
        schema.add_fields = this.add_fields;
        return schema;
    }

    destroy() {
        // @ts-ignore
        if($().mselect2){
            let sel = $(this.domElements.main).find('.mapsvg-select2');
            if(sel.length){
                //@ts-ignore
                sel.mselect2('destroy');
            }
        }
    }


    getDataForTemplate(): { [p: string]: any } {

        let data = super.getDataForTemplate();

        if (this.formBuilder.admin)
            data.post_types = this.formBuilder.admin.getPostTypes();
        data.post_type = this.post_type;
        data.post = this.post;
        data.add_fields = this.add_fields || 0;
        return data;
    }

    setEventHandlers() {
        super.setEventHandlers();

        let _this = this;

        let server = new Server();

        // @ts-ignore
        $(this.inputs.postSelect).mselect2({
            placeholder: 'Search post by title',
            allowClear: true,
            ajax: {
                url: server.getUrl('posts'), //MapSVG.urls.ajaxurl + '?action=mapsvg_search_posts&post_type=' + this.post_type,
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    return {
                        filters: {post_type: _this.post_type},
                        search: params.term, // search term
                        page: params.page
                    };
                },
                processResults: function (data, params) {
                    // parse the results into the format expected by Select2
                    // since we are using custom formatting functions we do not need to
                    // alter the remote JSON data, except to indicate that infinite
                    // scrolling can be used
                    params.page = params.page || 1;

                    return {
                        results: data.posts ? data.posts : [],
                        pagination: {
                            more: false //(params.page * 30) < data.total_count
                        }
                    };
                },
                cache: true
            },
            escapeMarkup: function (markup) {
                return markup;
            }, // let our custom formatter work
            minimumInputLength: 1,
            templateResult: formatRepo, // omitted for brevity, see the source of this page
            templateSelection: formatRepoSelection // omitted for brevity, see the source of this page
        }).on('select2:select', function (e) {
            _this.post = e.params.data;
            // TODO change in php post ID to id (lowercase):
            $(_this.domElements.main).find(".mapsvg-post-id").text(_this.post.id);
            $(_this.domElements.main).find(".mapsvg-post-url").text(_this.post.url).attr('href', _this.post.url);
            $(_this.inputs.postId).val(_this.post.id);
            _this.value = _this.post.id;
            _this.events.trigger('change');
        }).on('change', function (e) {
            if (e.target.value === '') {
                $(_this.domElements.main).find(".mapsvg-post-id").text('');
                $(_this.domElements.main).find(".mapsvg-post-url").text('');
                $(_this.inputs.postId).val('');
                _this.value = '';
                _this.events.trigger('change');
            }
        });

        function formatRepo(repo) {
            if (repo.loading) {
                return repo.text;
            } else {
                return "<div class='select2-result-repository clearfix'>" +
                    repo.post_title + "</div>";
            }

        }

        function formatRepoSelection(repo) {
            return repo.post_title || repo.text;
        }
    }
}